import { eventsConstants } from '../constants'

export const loadEvents = () => {
  return {
    type: eventsConstants.EVENTS_INIT
  }
}

export const loadedEvents = (payload) => {
  return {
    type: eventsConstants.EVENTS_LOADED,
    payload
  }
}

export const failedEvents = () => {
  return {
    type: eventsConstants.EVENTS_FAILED
  }
}
